import api from "./api";

const EsimService = {
  async listRegions() {
    const r = await api.get("/esim/regions");
    return r.data;
  },
  async listCountries() {
    const r = await api.get("/esim/countries");
    return r.data;
  },
  async getCountry(id) {
    const r = await api.get(`/esim/countries/${id}`);
    return r.data;
  },
  async listPlans() {
    const r = await api.get("/esim/plans");
    return r.data;
  },
  async placeOrder(data) {
    const r = await api.post("/esim/orders", data);
    return r.data;
  },
  async listOrders() {
    const r = await api.get("/esim/orders");
    return r.data;
  },
};

export default EsimService;
